import React from "react";

export const Eplatform = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
         
          <div className="col-xs-12 col-md-12">
            <div className="about-text">
              <h2>GK E-platform</h2> 
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              <h3>{props.data ? props.data.WhyTitle : "loading..."}</h3>
              <div className="list-style">
                <div className="col-lg-4 col-sm-4 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why3.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
